'use client'

import { useAppSelector } from 'reducers/storeHooks';
import Home from './home/page';
import NotLoggedInComponent from 'components/notLoggedInComponent';

const MainPage = () => {
    const user = useAppSelector(state => state.userReducer.user)

    if (!user) {
        return <NotLoggedInComponent />
    }
    return <Home />
}

export default MainPage